<template>
  <main>
    <router-link
      :to="{ name: 'PaymentLinkListPage' }"
    >
      <div
        class="payment-link-navigation"
      >
        <bg-icon
          size="sm"
          name="left-arrow"
          color="grey-dark"
        />
        <bg-text
          type="body-md"
          color="grey-dark"
        >
          Voltar
        </bg-text>
      </div>
    </router-link>
    <bg-text
      type="h5"
      color="grey-dark"
    >
      Criar Link de Pagamentos com Pix
    </bg-text>
    <bg-card class="payment-link-card">
      <tr-form
        ref="form"
      >
        <tr-text-field
          v-model="formModel.name"
          label="Nome do link"
          name="name"
          placeholder="Link de Pagamentos"
          classes="col-lg-12"
          :maxlength="50"
        />
        <div class="width-100 payment-link-card__amount-container">
          <tr-text-field
            v-model="formModel.amount"
            label="Valor"
            name="value"
            placeholder="R$ 0,00"
            type="currency"
            classes="col-lg-6"
          />
          <tr-text-field
            v-model="formModel.expirationDate"
            label="Data de expiração"
            name="expirationDate"
            type="date"
            :disable-past-dates="true"
            placeholder="dd/mm/aaaa"
            classes="col-lg-6"
            class="payment-link-card__expiration-date"
          />
        </div>
        <tr-text-field
          v-model="formModel.description"
          label="Descrição (opcional)"
          name="description"
          type="textarea"
          placeholder="Descrição do link"
          :maxlength="100"
        />
        <div class="payment-link-card__buttons-container">
          <bg-button
            size="md"
            variant="outline"
            @click="openCancelDialog"
          >
            Cancelar
          </bg-button>
          <bg-button
            size="md"
            :disabled="isCreateButtonDisabled"
            @click="onCreatePaymentLink"
          >
            Criar Link de Pagamento
          </bg-button>
        </div>
      </tr-form>
    </bg-card>
  </main>
  <payment-link-cancel-dialog
    ref="cancelDialog"
  />
  <payment-link-success-dialog
    ref="successDialog"
  />
</template>;

<script setup>
import { computed, ref } from 'vue';
import { BgIcon, BgText, BgCard, BgButton } from '@transfeeradev/bridge';
import PaymentLinkCancelDialog from '@/apps/payin/paymentLink/components/PaymentLinkCancelDialog.vue';
import PaymentLinkSuccessDialog from '@/apps/payin/paymentLink/components/PaymentLinkSuccessDialog.vue';
import { createPaymentLink } from '@/apps/payin/paymentLink/services/paymentLink';
import { useErrorHandler } from '@/commons/composables/useErrorHandler';
import checkpoint from '@/commons/constants/checkpoint';
import checkpointResource from '@/commons/resources/checkpoint';

const { handleError } = useErrorHandler();

const cancelDialog = ref();
const successDialog = ref();
const form = ref();

const openCancelDialog = () => {
  cancelDialog.value.open();
};

const openSuccessDialog = paymentData => {
  successDialog.value.open(paymentData);
};

const onCreatePaymentLink = async () => {
  checkpointResource.create(checkpoint.PAYMENT_LINK_CREATE_CLICKED);
  try {
    const paymentData = await createPaymentLink(formModel.value);
    openSuccessDialog(paymentData);
  } catch (e) {
    handleError(e, 'Ocorreu um erro ao criar o Link de Pagamentos.');
  }
};

const formModel = ref({
  name: '',
  amount: '',
  expirationDate: '',
  description: ''
});

const isCreateButtonDisabled = computed(() => {
  return !formModel.value.name || !formModel.value.amount || !formModel.value.expirationDate;
});

const emit = defineEmits(['loading']);
emit('loading', false);
</script>

<style scoped>
main {
  h5 {
    margin-top: var(--bg-spacing-md);
  }
}

.payment-link-navigation {
  display: flex;
  align-items: center;
  gap: var(--bg-spacing-x-sm);
  margin-top: var(--bg-spacing-md);
  cursor: pointer;
}

.payment-link-card {
  margin-top: var(--bg-spacing-sm);
  max-width: 50%;

  form {
    display: flex;
    flex-direction: column;

    div {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.payment-link-card__amount-container {
  display: flex;
  gap: var(--bg-spacing-sm);
}

.payment-link-card__buttons-container {
  align-self: flex-end;

  button:nth-last-child(1) {
    margin-left: var(--bg-spacing-sm);
  }
}
</style>